import countries from './../../../common/countries';

export function sessionRestored(state, account) {
  const country = countries.find(({ label }) => account.country === label);
  return {
    ...state,
    account: {
      ...state.account,
      ...account,
    },
    countries: {
      ...state.countries,
      states: country && country.states || [],
    },
  };
}

export function resetPassword(state) {
  return {
    ...state,
    account: {
      ...state.account,
      error: '',
      resetSuccess: false,
    },
  };
}

export function resetPasswordSuccess(state) {
  return {
    ...state,
    account: {
      ...state.account,
      resetSuccess: true,
    },
  };
}

export function resetPasswordFail(state) {
  return {
    ...state,
    account: {
      ...state.account,
      resetSuccess: false,
      error: 'Ooops! Something went wrong. Please try again.',
    },
  };
}

export function forgotPassword(state) {
  return {
    ...state,
    account: {
      ...state.account,
      error: '',
      forgotSuccess: false,
    },
  };
}

export function forgotPasswordSuccess(state) {
  return {
    ...state,
    account: {
      ...state.account,
      forgotSuccess: true,
    },
  };
}

export function forgotPasswordFail(state) {
  return {
    ...state,
    account: {
      ...state.account,
      forgotSuccess: false,
      error: 'Ooops! Something went wrong. Please try again.',
    },
  };
}

export function changeResetTokenExpirationStatus(state, status) {
  return {
    ...state,
    account: {
      ...state.account,
      isResetTokentExpired: status,
    },
  };
}



/** WEBPACK FOOTER **
 ** ./js/core/auth.js
 **/